<template>
  <div>
    <div class="video-cont">
      <VideoFrame />
    </div>
  </div>
</template>

<script>
import VideoFrame from '@/components/VideoFrame'

export default {
  components: { VideoFrame },
}
</script>

<style scoped>
@screen xl {
  .video-cont {
    @apply h-auto pb-0;
    height: 720px;
  }

  .player {
    @apply static;
  }
}
</style>
